import React, { useState } from "react";
import "./footer.css";
import Flag from "./image/flag.svg";
import tm_logo_tagline from "./image/tm_logo_tagline.svg";
import { Modal, Button } from "react-bootstrap";
import PrivacyPolicy from "../footer-component/privacyPolicy";
import CopyRightPolicy from "../footer-component/copyRightPolicy";
import TermsAndConditions from "../footer-component/termsConditions";
import Help from "../footer-component/help";

// import { FaPhone } from "react-icons/fa6";
// import { IoMail } from "react-icons/io5";
// import { FaLocationDot } from "react-icons/fa6";
import WhatsApp from "./image/whatsApp.svg";
import Instagram from "./image/instagram.svg";
import LinkedIn from "./image/linkedIn.svg";
import YouTube from "./image/youtube.svg";
import Facebook from "./image/facebook.svg";
// import Pintrest from "./image/pintrest.svg";

const Footer = () => {
  const [isCopied, setIsCopied] = useState(false);
  const [copiedMessage, setCopiedMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [activeComponent, setActiveComponent] = useState(null);

  const handleCopy = (text, type) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedMessage(`${type} Copied!`);
          setIsCopied(true);
          setTimeout(() => setIsCopied(false), 2000);
        })
        .catch(() => {
          console.error("Failed to copy text");
        });
    } else {
      // Fallback for older browsers or insecure contexts
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed"; // Prevent scrolling to the element
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        setCopiedMessage(`${type} Copied!`);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textArea);
    }
  };

  const handleShowModal = (component) => {
    setActiveComponent(component);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveComponent(null);
  };

  return (
    <div className="footer-content">
      <div className="logo-footer-div">
        <div
          className="logo-footer"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            setTimeout(() => window.location.reload(), 800);
          }}
          style={{ cursor: "pointer" }}
        >
          <img src={tm_logo_tagline} alt="logo-footer" />
          {/* <p className="footer-tagline">Converting Pixels Into Possibilities</p> */}
        </div>
      </div>

      <div className="policies">
        <h3>POLICIES</h3>
        <ul>
          <li>
            <span onClick={() => handleShowModal("PrivacyPolicy")}>
              Privacy Policies
            </span>
          </li>
          <li>
            <span onClick={() => handleShowModal("CopyRightPolicy")}>
              Copyright Policies
            </span>
          </li>
          <li>
            <span onClick={() => handleShowModal("TermsAndConditions")}>
              Terms and Conditions
            </span>
          </li>
          <li>
            <span onClick={() => handleShowModal("Help")}>Help</span>
          </li>
        </ul>

        {showModal && (
          <>
            {/* Backdrop */}
            <div className="modal-backdrop" onClick={handleCloseModal}></div>

            {/* Modal Content */}
            <div className="modal-content">
              <div>
                {activeComponent === "PrivacyPolicy" && <PrivacyPolicy />}
                {activeComponent === "CopyRightPolicy" && <CopyRightPolicy />}
                {activeComponent === "TermsAndConditions" && (
                  <TermsAndConditions />
                )}
                {activeComponent === "Help" && <Help />}
              </div>
            </div>
          </>
        )}
      </div>
      <div className="letsTalk">
        <h3>LET'S TALK</h3>

        <p
          className="info"
          onClick={() => handleCopy("+91 99883-08752", "Phone Number")}
          style={{ cursor: "pointer" }}
        >
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <p>+91 86996-21455</p>
        </p>

        <p
          className="info"
          onClick={() => handleCopy("contact@pixwala.com", "Email Address")}
          style={{ cursor: "pointer" }}
        >
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
              <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
            </svg>
          </div>

          <p>contact@pixwala.com</p>
        </p>

        <p className="info">
          <div className="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          {/* <p>ACIC RISE, CGC Landran, Mohali, Punjab, Pin- 140307</p> */}
          <a
            href="https://www.google.com/search?q=pixwala"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "none",
              color: "inherit",
              cursor: "pointer",
            }}
          >
            {/* ACIC RISE, CGC Landran, Mohali, Punjab, Pin-140307 */}
            {/* SCF-6, Oppo. Tribune Colony, Baltana, Zirakpur, Punjab, Pin- 140603 */}
            1st Floor, Next 57, Plot No. 25, next to Berkeley Hyundai,
            Industrial Area Phase I, Chandigarh, 160002
          </a>
        </p>
      </div>
      <div className="followUs">
        <h3>FOLLOW US ON</h3>
        <ul>
          <li className="social-media-icon">
            <a
              href="https://wa.me/+918699621455"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={WhatsApp} />
            </a>
          </li>
          <li className="social-media-icon">
            <a
              href="https://www.instagram.com/pixwalaindia"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={Instagram} />
            </a>
          </li>
          <li className="social-media-icon">
            <a
              href="https://www.linkedin.com/company/pixwala/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={LinkedIn} />
            </a>
          </li>
          <li className="social-media-icon">
            <a
              href="https://www.youtube.com/@PixWalaMoments"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={YouTube} />
            </a>
          </li>
        </ul>
      </div>
      <div className="img-p-flag">
        <img src={Flag} alt="flag" />
        <p>MADE WITH LOVE</p>
      </div>

      {/* Popup Notification */}
      {isCopied && <div className="copied-popup">{copiedMessage}</div>}
    </div>
  );
};
export default Footer;
